import React, { FC, useMemo } from "react";
import classnames from "classnames";
import { FullscreenTypeEnums } from "Data/settings";
import FullscreenTrackingView from "../fullscreen-tracking-view";
import useDeliveryFullscreen from "../use-delivery-fullscreen";
import { first } from "lodash";
import FullscreenAccessDenied from "Components/fullscreen-configuration/access-denied/fs-access-denied";

const url = new URL(window.location.href);
const segments = url.pathname.split("/");
const typeOfTracking = segments[2];
const id = segments[3];

const PublicFullscreen: FC = () => {
  const {
    upcomingBatches,
    trolleys,
    boxesSlot,
    boxes,
    accessForbidden,
    setAccessToForbidden,
    handleFetchPublicBoxList,
    handleFetchPublicTrolleyList,
  } = useDeliveryFullscreen({ isPublic: true });

  const handleCallAPI =
    typeOfTracking.toUpperCase() === FullscreenTypeEnums.RACK
      ? handleFetchPublicBoxList
      : handleFetchPublicTrolleyList;

  const trackingProps = {
    handleAPICallsByTabs: () => id && handleCallAPI(id),
    boxes,
    upcomingBatches,
    trolleys,
    boxesSlot,
    viewAccess: "PUBLIC",
    type: typeOfTracking.toUpperCase(),
    accessForbidden,
    setAccessToForbidden,
  };

  const name = useMemo(() => {
    if (typeOfTracking.toUpperCase() === FullscreenTypeEnums.RACK) {
      return first(boxesSlot)?.name;
    }

    return FullscreenTypeEnums.TROLLEY;
  }, [boxesSlot]);

  return (
    <div className="dfs-container">
      {accessForbidden ? (
        <FullscreenAccessDenied />
      ) : (
        <div className={classnames("fcv-inner")}>
          <div className="fcv-header">
            <div className="fcv-h-left">
              <div className="fcv-h-title dfs-h-nav">
                <span className={classnames("fcv-h-option active")}>{name}</span>
              </div>
            </div>
          </div>
          <FullscreenTrackingView {...trackingProps} />
        </div>
      )}
    </div>
  );
};

export default PublicFullscreen;
